//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import PartialCuid from '@models/PartialCuid';
import CommunicationType from '@models/RightsCommunicationType';

export interface IRequestRightsOAuthParams {
  targetUrl: string;
  approvalPhrase: string;
  requestMessage: string;
  itemId: PartialCuid;
  communicationType?: CommunicationType;
}

export const getInstagramOauthUrl = (itemParams: IRequestRightsOAuthParams) => {
  const itemParamString = encodeURIComponent(JSON.stringify(itemParams));
  const redirectUri = `${location.origin}/rights-request-oauth-landing`;

  const params = new URLSearchParams({
    client_id: CURALATE_ENV.INSTAGRAM_CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'user_profile',
    state: itemParamString,
  });

  return `https://api.instagram.com/oauth/authorize?${params.toString()}`;
};
